import { render, staticRenderFns } from "./MiniDecoration.vue?vue&type=template&id=76c52d7f&scoped=true"
import script from "./MiniDecoration.vue?vue&type=script&lang=js"
export * from "./MiniDecoration.vue?vue&type=script&lang=js"
import style0 from "./MiniDecoration.vue?vue&type=style&index=0&id=76c52d7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c52d7f",
  null
  
)

export default component.exports